// @ts-nocheck
// Agent Portal (/cti2) — the persistent Live-call card stack, split out of
// AgentPortalPage.tsx. Matches the mock's live-call "cti-v3-center" column
// and production's own IdleScreen.tsx pattern: CustomerProfileCard/
// CallScriptCard/DispositionCard are always mounted and decide their own
// visibility from useCallStore (isActive/hasDispContext) — the parent
// never branches on `screen` to show/hide them. Replaces the separate
// RingingScreen/DispositionScreen full-screen takeovers entirely — their
// Accept/Reject is now the Dialer-rail buttons, their ringtone audio has
// its own home in useScreenState. Call controls (mute/hold/transfer/conf/
// hang-up) already live in Dialer.tsx and stay visible regardless of
// screen, so nothing here duplicates them; Transfer/Conference already
// route to the shared TransferConferencePicker in AgentPortalPage.tsx.
// Pending dispositions are no longer a separate full-screen takeover
// (PendingDispositionsPanel) — DispositionCard's own Live/Pending tabs
// (same pattern as CallScriptCard's Script/Objections tabs) show that
// list inline, right here.
import React from 'react';
import CustomerProfileCard from '@/features/cti/components/CustomerProfileCard';
import CallScriptCard from '@/features/cti/components/CallScriptCard';
import DispositionCard from '@/features/cti/components/DispositionCard';
import LiveCallTranscript from './LiveCallTranscript';

export default function LiveCallStack({
  hideScript = false,
  transcriptionEnabled = false,
  contextScript,
  contextScriptSource,
  contextScriptLoading,
  dispositionMeta,
  dispositionValues,
  setDispositionValues,
  dispositionErrors,
  setDispositionErrors,
  remarkStatusList,
  dispositionSubmitting,
  onSubmitDisposition,
  onSubmitDispositionAndNext,
  editingSubmitted,
  onEditSubmitted,
  onCancelEditSubmitted,
  customerHistory,
  userData,
  dispositionSecondsLeft,
  lastSubmittedDisposition,
  pendingDispositions,
  onSubmitPending,
  onSubmitPendingAndNext,
  maskNumbers,
}) {
  return (
    <div className="cti-live-stack flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-1">
      <CustomerProfileCard showQualityIndicator />
      {transcriptionEnabled && <LiveCallTranscript agentName={userData?.name || 'Agent'} />}
      {!hideScript && (
        <CallScriptCard
          contextScript={contextScript}
          contextScriptSource={contextScriptSource}
          contextScriptLoading={contextScriptLoading}
          showObjectionsTab={false}
        />
      )}
      <DispositionCard
        dispositionMeta={dispositionMeta}
        dispositionValues={dispositionValues}
        setDispositionValues={setDispositionValues}
        dispositionErrors={dispositionErrors}
        setDispositionErrors={setDispositionErrors}
        remarkStatusList={remarkStatusList}
        dispositionSubmitting={dispositionSubmitting}
        onSubmit={onSubmitDisposition}
        onSubmitAndNext={onSubmitDispositionAndNext}
        editingSubmitted={editingSubmitted}
        onEditSubmitted={onEditSubmitted}
        onCancelEditSubmitted={onCancelEditSubmitted}
        customerHistory={customerHistory}
        userData={userData}
        dispositionSecondsLeft={dispositionSecondsLeft}
        dispositionTotalSeconds={dispositionMeta?.wrap_up_seconds ?? null}
        lastSubmittedDisposition={lastSubmittedDisposition}
        pendingDispositions={pendingDispositions}
        onSubmitPending={onSubmitPending}
        onSubmitPendingAndNext={onSubmitPendingAndNext}
        maskNumbers={maskNumbers}
      />
    </div>
  );
}
